import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useRef, useState } from 'react';
import { searchLink } from '../../documents/data';
var SearchForm = function SearchForm(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    ifFocusableOnLoad = _ref.ifFocusableOnLoad,
    toShowCopyOnFocus = _ref.toShowCopyOnFocus,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder,
    _ref$toShowSecurityMe = _ref.toShowSecurityMessage,
    toShowSecurityMessage = _ref$toShowSecurityMe === void 0 ? true : _ref$toShowSecurityMe,
    id = _ref.id,
    homepage = _ref.homepage;
  var inp = useRef(null);
  var _useState = useState(!toShowCopyOnFocus),
    _useState2 = _slicedToArray(_useState, 2),
    toShowCopy = _useState2[0],
    setToShowCopy = _useState2[1];
  useEffect(function () {
    if (ifFocusableOnLoad && inp.current) {
      inp.current.focus();
    }
  }, [ifFocusableOnLoad]);
  var handleFocus = function handleFocus() {
    if (toShowCopyOnFocus) {
      setToShowCopy(true);
    }
  };
  var handleBlur = function handleBlur() {
    if (toShowCopyOnFocus) {
      setToShowCopy(false);
    }
  };
  var handleSubmit = function handleSubmit(event) {
    var _inp$current;
    event.preventDefault();
    var query = ((_inp$current = inp.current) === null || _inp$current === void 0 ? void 0 : _inp$current.value) || '';
    var url = "".concat(searchLink, "#q=").concat(encodeURIComponent(query)).concat(homepage ? '&tmpl=home' : '');
    window.location.href = url;
  };
  return React.createElement(React.Fragment, null, React.createElement("form", {
    className: "bg-white border ".concat(className),
    name: "global-form",
    method: "get",
    autoComplete: "off",
    spellCheck: "false",
    onSubmit: handleSubmit
  }, React.createElement("div", {
    className: "input-group",
    id: id
  }, React.createElement("label", {
    htmlFor: "".concat(id, "-input"),
    className: "visually-hidden"
  }, placeholder), React.createElement("input", {
    id: "".concat(id, "-input"),
    ref: inp,
    onFocus: handleFocus,
    onBlur: handleBlur,
    type: "text",
    className: "form-control border-end-0 border border-white",
    placeholder: placeholder,
    name: "q"
  }), React.createElement("button", {
    className: "btn ecs-font-icon-act-search border-0 text-secondary h5 mb-0",
    type: "submit",
    "aria-label": placeholder
  }))), toShowCopy && toShowSecurityMessage && React.createElement("p", {
    className: "p-2 body-text-xs mb-0"
  }, "Don\u2019t enter personal info like your SSN, email or phone number"));
};
export default SearchForm;